module.exports = __webpack_public_path__ + "ec7238e2c43184a778e22cc71f385ddb.MP3";